module.exports = __webpack_public_path__ + "static/img/dd-customer-08.81ff81e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-customer-08.jpg
// module id = j7Zv
// module chunks = 1